import HeadProfile from "./HeadProfile";

export default HeadProfile;
